const spacing = 5;

function setSpacing(val: number | number[]) {
  if (typeof val === 'object') {
    return val.map(v => `${v * spacing}px`).join(' ');
  }
  return val * spacing;
}

export default setSpacing;
